import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { CustomerPersonItem, EconomyService } from '../../../services/economy.service';

@Component({
  selector: 'tt-customer-persons',
  templateUrl: './customer-persons.component.html',
  styleUrls: ['./customer-persons.component.css'],
  standalone: false
})
export class CustomerPersonsComponent implements OnInit {
    public custNo: string | number;

    public setting?: Setting;

    public itemsListCustomerPersons: CustomerPersonItem[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService, private economy: EconomyService) {
        this.custNo = this.stateService.getStateParams()['cust_no'];
    }

    private async loadSetting() {
        if (!!this.custNo) {
            this.setting = (await this.datatask.Post(900, { cust_no: this.custNo }))[0];
        }
    }

    private async loadCustomerPersons() {
        if (!!this.custNo) {
            this.itemsListCustomerPersons = await this.economy.getCustomerPersons({ cust_no: this.custNo as number });
        }
    }

    private async init() {
        this.loadSetting();
        this.loadCustomerPersons();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    emailcreate_heading: string;
}
